import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'

import { BreadcrumbProps } from '../Breadcrumb'
import { ActionButtonProps } from '../ActionButton'
import { useRichText } from '../../relay/RichText/useRichText'
import RichText from '../RichText'

import * as SC from './styled'

export type BannerListingProps = {
  className?: string
  title?: string
  text?: string | any[] | null
  textCategory?: string
  breadcrumb?: BreadcrumbProps
  offersNumber?: string
  linkButton?: ActionButtonProps
  background?: ImageProps
  imageRight?: ImageProps
}

const BannerListing: FC<BannerListingProps> = ({
  className,
  breadcrumb,
  title,
  text,
  textCategory,
  offersNumber,
  linkButton,
  background,
  imageRight,
}) => {
  const richTextProps = useRichText(text)

  return (
    <SC.Banner className={cx('BannerListing', className)}>
      {background && (
        <SC.Background
          {...background}
          priority={true}
          width={1440}
          height={480}
        />
      )}
      <SC.BannerWrapper>
        <SC.Content>
          {breadcrumb && <SC.Bdc {...breadcrumb} />}
          {title && <SC.Title>{title}</SC.Title>}
          {textCategory && <SC.Text>{textCategory}</SC.Text>}
          {text && <RichText {...richTextProps} />}
          {offersNumber && <SC.Offers>{offersNumber}</SC.Offers>}
          {linkButton && <SC.LinkButton {...linkButton} />}
        </SC.Content>
        {imageRight && (
          <SC.ImageBlock>
            <SC.ImageRight {...imageRight} priority={true} />
          </SC.ImageBlock>
        )}
      </SC.BannerWrapper>
    </SC.Banner>
  )
}

export default BannerListing
